import React from 'react';

const FormInputTextArea = ({register,error,label,id,...inputProps}) => {
    return <>
    	<div className="form-group">
            <label htmlFor={id}>{label}</label>
            <textarea
                {...register(id)}
                id={id}
                className={`form-control ${error ? "is-invalid" : ""}`}
                {...inputProps}
            />
            {error && <div className="invalid-feedback">{error.message}</div>}
        </div>
    </>
};
export default FormInputTextArea;